import { useSettings } from "@/context/SettingsContext";
import { airhorn, CONFETTI_STYLES, fireConfetti, playSound, SOUND_PACKS } from "@/lib/fun";
import { Pick, Row, Section, TestButton, Toggle } from "@/components/settings/Controls";

const OVERDUE = [
  { value: "none", label: "Leave it alone" }, { value: "red", label: "Slowly turn red" },
  { value: "wobble", label: "Wobble" }, { value: "sass", label: "Passive-aggressive" },
];
const WALL_FUN = [
  ["celebrate", "Confetti when someone hits their call target"], ["airhorn", "Airhorn when a target is hit"],
  ["crown", "Crown on today's top caller"], ["friday_countdown", "Friday 5pm countdown"],
  ["mute_counter", "\"Days Since We Fucked Up\" counter"], ["birthday_banners", "Birthday & anniversary balloons"],
  ["tea_round", "Random Wheel"], ["leaderboard", "Weekly leaderboard"],
];

export const FunTab = () => {
  const { prefs, savePrefs, team, saveTeam } = useSettings();
  return (
    <div className="space-y-6">
      <Section title="Celebrations (just you)" hint="What happens when you tick a task off." testid="settings-celebrations">
        <Toggle label="Confetti on task complete" checked={prefs.confetti} onChange={(v) => savePrefs({ confetti: v })} testid="fun-confetti" />
        <Row label="Confetti style">
          <Pick value={prefs.confetti_style} onChange={(v) => savePrefs({ confetti_style: v })} options={CONFETTI_STYLES} testid="fun-confetti-style" />
          <TestButton onClick={() => fireConfetti(prefs.confetti_style)} testid="fun-confetti-test">Try it</TestButton>
        </Row>
        <Toggle label="Sounds" checked={prefs.sounds} onChange={(v) => savePrefs({ sounds: v })} testid="fun-sounds" />
        <Row label="Sound pack" hint="For completed tasks and new alerts.">
          <Pick value={prefs.sound_pack} onChange={(v) => savePrefs({ sound_pack: v })} options={SOUND_PACKS} testid="fun-sound-pack" />
          <TestButton onClick={() => playSound(prefs.sound_pack)} testid="fun-sound-test">Play</TestButton>
        </Row>
        <Toggle label="AI compliment when you close a ticket" checked={prefs.compliments} onChange={(v) => savePrefs({ compliments: v })} testid="fun-compliments" />
      </Section>
      <Section title="Overdue tasks (just you)" testid="settings-overdue-style">
        <Row label="What overdue tasks do" hint="On your reminder lists."><Pick value={prefs.overdue_style} onChange={(v) => savePrefs({ overdue_style: v })} options={OVERDUE} testid="fun-overdue-style" /></Row>
      </Section>
      <Section title="Secrets & comfort" testid="settings-secrets">
        <Toggle label="Konami code easter egg" hint="Up Up Down Down Left Right Left Right B A. You didn't hear it from us." checked={prefs.konami} onChange={(v) => savePrefs({ konami: v })} testid="fun-konami" />
        <Toggle label="Reduce motion" hint="Turns off animations, wobbles and confetti." checked={prefs.reduce_motion} onChange={(v) => savePrefs({ reduce_motion: v })} testid="fun-reduce-motion" />
      </Section>
      {team && (
        <Section title="Wallboard fun (whole team)" hint="What the office TV shows." testid="settings-wall-fun">
          {WALL_FUN.map(([k, label]) => <Toggle key={k} label={label} checked={team.wallboard[k]} onChange={(v) => saveTeam({ wallboard: { [k]: v } })} testid={`wall-fun-${k}`} />)}
          <Toggle label="Weekly awards" hint="Ticket Terminator, Update Machine, Most Snoozed, Phone Glued To Ear." checked={team.fun.awards} onChange={(v) => saveTeam({ fun: { awards: v } })} testid="wall-fun-awards" />
          <Row label="Test the airhorn"><TestButton onClick={airhorn} testid="fun-airhorn-test">Honk</TestButton></Row>
        </Section>
      )}
    </div>
  );
};
